<template lang="pug">
PrChoose.pr-choose(v-bind="$props")
  .choose-wrapper
    .label.text-muted.font-weight-bold.small(v-show="label") {{ label }}
    .items 
      .item.bordered(v-nv @nv-enter="choose(item)" v-for="(item, index) in items", :key="index", :class="{ activated: item.selected }") {{ item.value }}
</template>

<script>
import styled from "vue-styled-components"

const Props = {
  label: String,
  value: String,
  options: Array,
  xsmall: Boolean,
  small: Boolean,
  outline: Boolean,
  floated: Boolean,
  multiple: Boolean
}
const PrChoose = styled("div", Props)`
  position-relative;

  .choose-wrapper {
    display: flex;
    align-items: center;
    position: relative;
    max-width:100%;

    .label {
      max-width: 40%;
      min-width: 40%;
      overflow: hidden;
      margin-right: 15px;
      white-space: nowrap;
      ${props => (props.label && props.floated ? "position:absolute; top:0;" : "")};
    }
    .items {
      display:flex;
      flex-direction:row;
      flex-wrap:wrap;
      justify-content:space-between;
      flex-grow:1;
      ${props => (props.label && props.floated ? "margin-top:30px; margin-left:-5px; max-width:100%;" : "max-width:60%;")};
    }
    .item {
      display:inline-flex;
      flex-grow:1;
      justify-content:center;
      padding: 5px 10px;
      font-size: 80%;
      font-weight: ${props => props.theme.font.semibold};

      ${props => (props.floated ? "margin:0 0 5px 5px; " : "margin:0 0 5px 1px;")};
      ${props => "border: 2px solid " + (props.outline ? props.theme.color.onSurface : props.theme.color.border) + ";"}

      &.activated {
        background: ${props => props.theme.color.onSurface};
        color: ${props => props.theme.color.surface};
        border: 2px solid ${props => props.theme.color.surface};
      }
    }
  }
  background: ${props => (props.theme.options.outline || props.outline ? "transparent" : props.theme.color.surface)};
  color: ${props => props.theme.color.onSurface};
  ${props => "border: 1px solid " + (props.outline ? props.theme.color.onSurface : props.theme.color.border) + ";"}
  ${props =>
    props.xsmall
      ? "padding: 0.35em 1em; font-size: " + props.theme.font.xsmall + ";"
      : props.small
      ? "padding: 0.5em 1.25em; font-size: " + props.theme.font.small + ";"
      : "padding: 0.75em 1.5em; font-weight:300; font-size: " + props.theme.font.base + ";"}
`

export default {
  name: "pr-choose",
  components: {
    PrChoose
  },
  props: {
    ...Props
  },
  computed: {
    items() {
      let pool = Array.isArray(this.value) ? this.value : this.value ? this.value.split(",") : []
      return this.options.map(option => {
        return { value: option, selected: pool.indexOf(option) >= 0 }
      })
    }
  },
  watch: {
    value() {
      this.$nextTick(() => {
        _$.nav._currentScope.currentElement.classList.add("nv")
        _$.nav._currentScope.currentElement.classList.add("nv-el-current")
      })
    }
  },
  methods: {
    choose(item) {
      if (!this.multiple) {
        this.$emit("update:value", item.value)
        return
      }

      let newValues = Array.isArray(this.value) ? this.value : this.value ? this.value.split(",") : []
      if (newValues.indexOf(item.value) >= 0) newValues = _$.removeFromArray(newValues, item.value)
      else newValues.push(item.value)
      this.$emit("update:value", newValues.length ? newValues.join() : null)
    }
  }
}
</script>
